import Dropdown from "~/components/shared/Dropdown";
import Icon from "~/components/shared/Icon";
import DropdownContent from "~/components/Settings/Usage/DatePicker/DropdownContent";
import {
  DatePickerProps,
  formatDatePeriod,
  UsagePeriod,
} from "~/components/Settings/Usage/DatePicker/helper";

const Button = ({ currentPeriod }: { currentPeriod: UsagePeriod }) => (
  <button className="rounded-2 hover-purple border-gray m-0 flex cursor-pointer items-center justify-center border bg-white px-2 py-1 text-sm">
    {formatDatePeriod(currentPeriod)}
    <Icon
      icon="down-triangle"
      className="flex-none"
      style={{
        width: 7,
        height: 7,
        marginLeft: ".5em",
      }}
    />
  </button>
);

const DatePicker = ({ usagePeriod, recentSubscriptionsPeriod }: DatePickerProps) => (
  // @ts-expect-error - TS2769 - No overload matches this call.
  <Dropdown width="460" className="usage-datepicker flex flex-none">
    <Button currentPeriod={usagePeriod} />
    <DropdownContent recentSubscriptions={recentSubscriptionsPeriod} />
  </Dropdown>
);

export default DatePicker;
